import { FieldArrayModel, ValidateErrorContext } from 'forms/shared/types';
import { BaseCustomValidator } from '../types';

const arrayBaseValidator: BaseCustomValidator<FieldArrayModel> = (validateModel) => (
  value,
  options,
  key,
  attributes,
  globalOptions
) => {
  let { values } = { values: [], ...value };
  if (values === undefined || values === null) { values = []; }

  const { validator, ...rest } = options;

  let errors: ValidateErrorContext[] = [];

  if (rest.length) {
    const arrayErrors = validateModel(
      { array: values },
      { array: { ...rest } },
      { ...globalOptions }
    );
    if (typeof arrayErrors !== 'boolean') { errors = [...errors, ...arrayErrors]; }
  }

  let itemsErrors: any[] = [];

  // Potential TODO: Add index
  if (validator) {
    values.forEach((value2) => {
      const itemErrors = validateModel(
        { value: value2 },
        { value: validator },
        { ...globalOptions, ...options }
      );
      if (typeof itemErrors !== 'boolean') { itemsErrors = itemsErrors.concat(itemErrors.map((e) => e)); }
    });
  }

  if (itemsErrors.length > 0) { errors = [...errors, ...itemsErrors]; }

  if (errors.length > 0) { return errors; }

  return null;
};

export default arrayBaseValidator;
